export type VolumeIcon = 'method' | 'rhythm' | 'harmony' | 'language' | 'improv' | 'jam'

export interface Volume {
  number: string
  title: string
  description: string
  contents: string[]
  icon: VolumeIcon
  /** Accent color for the volume's icon tile. */
  accent: string
}

export const volumes: Volume[] = [
  {
    number: '01',
    title: 'The Jazz Teaching Method',
    description:
      'The framework behind the whole system: how to structure a year, sequence a lesson, and move a student from level to level.',
    contents: ['Lesson Structure', 'Year Planning', 'Level Criteria', 'Assessment'],
    icon: 'method',
    accent: '#2E5B4A',
  },
  {
    number: '02',
    title: 'Swing & Comping Mastery',
    description:
      '50 complete sessions on swing feel, comping patterns, and rhythmic architecture — all with structured progressions.',
    contents: ['Swing Feel', 'Comping Patterns', 'Groove Mastery', 'Rhythm Drills'],
    icon: 'rhythm',
    accent: '#1F3A5F',
  },
  {
    number: '03',
    title: 'Chords & Progressions Mastery',
    description:
      'Chord theory, ii-V-I in every key, voice leading, and substitutions — lesson by lesson progression.',
    contents: ['7th Chords', 'ii-V-I in All Keys', 'Tritone Subs', 'Voice Leading'],
    icon: 'harmony',
    accent: '#C08A2E',
  },
  {
    number: '04',
    title: 'Jazz Language & Phrasing',
    description:
      'Licks, articulation, and phrasing worked out so students stop playing scales and start speaking the language.',
    contents: ['Articulation', 'Vocabulary', 'Phrase Building', 'Transcription'],
    icon: 'language',
    accent: '#4A3524',
  },
  {
    number: '05',
    title: 'Improvisation & Soloing',
    description:
      'A step-by-step path from guide tones to full choruses, with drills and standards mapped for each stage.',
    contents: ['Guide Tones', 'Modes & Arpeggios', 'Solo Building', 'Standards'],
    icon: 'improv',
    accent: '#8E3232',
  },
  {
    number: '06',
    title: 'Jam Session Mastery',
    description:
      'Everything students need to play with others: counting in, trading choruses, etiquette, and ensemble routines.',
    contents: ['Ensemble Play', 'Trading Choruses', 'Etiquette', 'Group Routines'],
    icon: 'jam',
    accent: '#2B4A4E',
  },
]
